/* @flow strict */

import * as React from 'react';
// import { LoadScript } from '@react-google-maps/api';
import {
  GoogleMap,
  Marker
} from '@react-google-maps/api';
import { mapOptions } from './mapOptions';
import { themes } from './mapTheme';
import { theme2 } from './mapTheme2';
import HoverSplash from './../hoverSplash';

type PropsType = {
  withoutEdit?: boolean,
  p: {
    map_zoom: number,
    lat: number,
    lng: number,
    background_color?: string
  },
  handleSetZoom?: (zoom: number) => void
};

const MapTicket = (props: PropsType): React.Element<'div'> => {
  const { withoutEdit, p } = props;
  const [map, setMap] = React.useState(null);

  const handleZoomChanged = () => {
    if (!map || !props.handleSetZoom) return;
    props.handleSetZoom(map.getZoom());
  };

  return (
    <div className="splash-section splash-section-map splash_section_light" id='map'>
      <div className="splash-container-fluid">

          <GoogleMap
            id="navigation"
            onLoad={m => {
              setMap(m);
            }}
            style={{ height: '100%' }}
            mapContainerStyle={{
              height: '100%'
            }}
            options={{
              ...mapOptions,
              styles: p.background_color ? themes[p.background_color.toLowerCase()] : theme2
            }}
            zoom={p.map_zoom}
            center={{
              lat: p.lat,
              lng: p.lng
            }}
            onZoomChanged={(): void => handleZoomChanged()}
          >
          <Marker
            position={{
              lat: p.lat,
              lng: p.lng
            }}
            icon={{
              url: '/img/map/icon-marker@80.png',
              size: {
                height: 40,
                width: 40
              },
              scaledSize: { width: 40, height: 40 }
            }}
          />
          </GoogleMap>
      </div>

      {!withoutEdit && <HoverSplash {...props} />}
    </div>
  );
};

export default MapTicket;
